import React, { useState } from 'react';
import OrderHeader from '../Order/OrderHeader/OrderHeader';

const AddAdmin = () => {
    const [admin, setAdmin] = useState({})
    const[success, setSuccess] = useState('')
    const handleBlur = (e) => {
        setAdmin({...admin, [e.target.name]: e.target.value})
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        const adminUser = {...admin}
        fetch('https://assignment-11-samiun.herokuapp.com/addAdmin', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(adminUser)  
        })
        .then(res => res.json())
        .then(data => {
            if(data){
                setSuccess('Admin added Successfully')
            }
        })
    }
    return (
        <div className="row">
            <div className="col-md-2">
                <OrderHeader/>
            </div>
            <div className="col-md-10 mt-4">
            <div className="d-flex justify-content-between">
                <h3 className="mb-2">Make Admin</h3>
            </div>
            <div className="mt-3 ps-5 pt-5" style={{background: '#F4F7FC', height: '100vh'}}>
            <form onSubmit={handleSubmit}>
                <input type="text" class="form-control mb-4" placeholder="name" style={{width: '500px', border: 'none'}} name="name" required onBlur={handleBlur}/>
                <input type="email" class="form-control" placeholder="email" style={{width: '500px', border: 'none'}} name="email" required onBlur={handleBlur}/>
                <button type="submit" className="btn-style mt-4" style={{width: '500px'}}>Submit</button>
                {success && <div className="alert alert-success mt-3">{success}</div>}
                </form>
            </div>
            </div>
        </div>
    );
};

export default AddAdmin;